import * as React from 'react'
import { Card, Grid, IconButton, Menu, MenuItem, CardContent, CardMedia, CardActions } from '@mui/material';
import { UserImageStore } from '@af-common/UserData/_stores/UserImagesStore';
import PromptContainer from '@af-common/Common/_containers/PromptContainer';
import { Trans } from 'react-i18next';
import { MoreVert, Done, Edit, Delete } from '@mui/icons-material';

export type Props = {
	onRename?: Function
	onDelete?: Function
	item?: UserImageStore
	selected?: boolean
	onSelect?: Function
	onClose?: Function
}

type State = { 
	menuOpen: boolean 
	menuRenameOpen: boolean
	menuDeleteOpen: boolean
	elem: HTMLElement | null
}

const T = ({children, ...otherProps}:any) => <Trans ns="create" {...otherProps}>{children}</Trans>

export default class LibraryBrowserItem extends React.Component<Props, State> {
	state:State = { 
		menuOpen: false,
		menuRenameOpen: false,
		menuDeleteOpen: false,
		elem: null
	};

	private setElem = (element:HTMLElement) => {
		if (this.state.elem) return;
		this.setState({elem: element});
	}

	private onItemSelect = () => {
		this.setState({menuOpen: false});
		this.props.onSelect(this.props.item);
		this.props.onClose();
	}

	private onMenuButton = (e:React.MouseEvent) => {
		e.stopPropagation();
		this.setState({menuOpen: !this.state.menuOpen});
	}

	private onMenuSelect = () => {
		this.setState({menuOpen: false});
		this.props.onSelect(this.props.item);
	}

	private onMenuRename = (name:string) => {
		let fd = new FormData();
		fd.append('id', this.props.item.get('id'));
		fd.append('name', name)
		this.props.onRename(fd);
	}

	private onMenuDelete = () => {
		let fd = new FormData();
		fd.append('id', this.props.item.get('id'));
		this.props.onDelete(fd);
	}

	private onMenuRenameOpen = () => this.setState({menuOpen: false, menuRenameOpen: true});
	private onMenuRenameClose = () => this.setState({menuRenameOpen: false});

	private onMenuDeleteOpen = () => this.setState({menuOpen: false, menuDeleteOpen: true});
	private onMenuDeleteClose = () => this.setState({menuDeleteOpen: false});

	private killEvent = (e:React.MouseEvent) => {
		e.preventDefault();
		e.stopPropagation();
	}

	render = () => {
		return <Grid item key={this.props.item.get('id')}  xs={4} sm={4} lg={3}>
			<Card className="condensed">
				<CardContent onClick={this.onItemSelect}>
					<CardMedia image={this.props.item.get('filename')} />
				</CardContent>
				<CardActions>
					<h4>{this.props.item.get('name')}</h4>
					<IconButton onClick={(e:React.MouseEvent) => this.onMenuButton(e)}>
						<span className='mdc-menu-surface--anchor' ref={this.setElem}>
							<MoreVert />
						</span>
					</IconButton>
				</CardActions>
			</Card>
			<Menu
				id="simple-menu"
				anchorEl={this.state.elem}
				keepMounted
				open={this.state.menuOpen}
				onClose={() => this.setState({menuOpen: false})}
			>
				<MenuItem onClick={this.onMenuSelect}>
					<Done /><T>Select</T>
				</MenuItem>
				<MenuItem onClick={this.onMenuRenameOpen}>
					<Edit /><T>Rename</T>
				</MenuItem>
				<MenuItem onClick={this.onMenuDeleteOpen}>
					<Delete /><T>Delete</T>
				</MenuItem>
			</Menu>
			{/* Rename Dialog */}
			<PromptContainer
				opened={this.state.menuRenameOpen}
				title={<T>Rename Image</T>}
				input={this.onMenuRename}
				name={this.props.item.get('name')}
				onClose={this.onMenuRenameClose}
				dismissible
			/>
	
			{/* Delete Confirmation */}
			<PromptContainer
				opened={this.state.menuDeleteOpen}
				title={<T>Delete {{ name: this.props.item.get('name') }}</T>}
				message={<T>Are you sure that you want to delete this image?</T>}
				onClose={this.onMenuDeleteClose}
				actions={{
					"Delete": this.onMenuDelete
				}}
				dismissible
			/>
		</Grid>
	}
}